import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGift, faMapMarkerAlt, faCity, faStar, faGlobe, faBook, faBookOpen, faDownload, 
  faGifts, faHandsHelping, faPhone, faRainbow, faShoppingCart, faStore, faVideo, 
  faClock, faBriefcase, faUserTie, faClipboardQuestion, faSearch, faHandshake, 
  faCommentDots, faShieldAlt, faAward, faChartLine, faGraduationCap, faCogs, faMoneyCheckAlt, 
  faShieldHalved, faEnvelopeOpenText, faClipboardList, faFileAlt, faQrcode 
} from '@fortawesome/free-solid-svg-icons';
import './JobsWorks.css';
// import jobsworksimage from '../../assets/pageimages/jobsworksimage.webp';

function JobsWorksHome() {

  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 mt-12">
        <h2 className='text-3xl font-bold text-white text-center mb-6'>Jobs & Works</h2>
        <div className="min-h-[100vh] px-4">
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-250">
            <CardLink to="/resume-list" icon={faFileAlt} text="My Resume" />
            <CardLink to="/jd-list" icon={faClipboardList} text="Job Description (JD)" />
            <CardLink to="/coverletter-list" icon={faEnvelopeOpenText} text="My Cover Letter" />
            <CardLink to="/chronocheck-home" icon={faClock} text="Time Tracker" />
            <CardLink to="/bpmjobs-home" icon={faBriefcase} text="BPM Consultants" />
            <CardLink to="/fortyfivejobs-home" icon={faUserTie} text="Job Over 45 Years" />
            
            <CardNoLink icon={faClipboardQuestion} text="JobBoard" />
            <CardNoLink icon={faSearch} text="Seek Job" />
            <CardNoLink icon={faBriefcase} text="Post Job" />
            <CardNoLink icon={faStar} text="Instant Jobs" />
            <CardNoLink icon={faHandshake} text="Instant Interaction" />
            <CardNoLink icon={faCommentDots} text="Consultants Ratings" />
            <CardNoLink icon={faShieldAlt} text="Verified Recruiters" />
            <CardNoLink icon={faAward} text="Certified Freelancers" />
            <CardNoLink icon={faBook} text="Job Work Diary" />
            <CardNoLink icon={faChartLine} text="Expert Services" />
            <CardNoLink icon={faGraduationCap} text="Intern Positions" />
            <CardNoLink icon={faStore} text="Retail Positions" />
            <CardNoLink icon={faCogs} text="SME Support" />
            <CardNoLink icon={faMoneyCheckAlt} text="Job Payments" />
            <CardNoLink icon={faShieldHalved} text="Job Payment Protection" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default JobsWorksHome;
